import { Injectable, inject } from "@angular/core";
import { Resolve } from "@angular/router";
import { Observable } from "rxjs";

import { GenericItems } from "../../interfaces/generic-items.interface";
import { LorenNotification } from "../../services/loren-notification-service/interfaces/loren-notification.interface";
import { LorenNotificationService } from "../../services/loren-notification-service/loren-notification.service";

@Injectable({
  providedIn: "root",
})
export class LorenNotificationsResolver
  implements Resolve<GenericItems<LorenNotification>>
{
  private lorenNotificationService = inject(LorenNotificationService);


  resolve(): Observable<GenericItems<LorenNotification>> {
    return this.lorenNotificationService.getUserNotifications();
  }
}
